import React from 'react';
import SuiteImport from './SuiteImport';
import { useApp } from '../../core/AppContext';
import { VmMembersPanel, ChallengerArena } from './ChallengerArena';
import PrescreenRulesTab from './PrescreenRulesTab';
import ModelSearchTab from './ModelSearchTab';

export default function ModelEvalView() {
  const { getAuthHeaders, activeTab, agentLogs, batchResult, can, discoveredModels, echostarCatalog, otherCatalog, fetchCatalogs, fetchSuitesCatalog, deleteSuite, fetchSystemLogs, fetchedLogs, filteredDiscovered, filteredEchostar, filteredOther, filteredSuites, fmtCostPerMCell, getGovernanceAnalysis, handleAddGoldenSuite, handleEvaluateAllModels, handleImportAndEvaluateFromMarket, handleRunEvaluation, handleVmFlip, handleVmPull, handleVmPush, pushOpts, pushVmPick, setPushOpts, setPushVmPick, isSelfHostableModel, loading, marketScanDays, setMarketScanDays, modelId, newSuiteData, renderModelScorecard, renderModelTable, role, scanArtificialAnalysisMarket, scorecard, searchQuery, selectedLogComponent, setActiveTab, setBatchResult, setModelId, setNewSuiteData, setSearchQuery, setSelectedLogComponent, setShowAddSuiteModal, showAddSuiteModal, statusMsg, suitesCatalog, vmStatus, tfEnabled, tfPulledAt, pullTruefoundryModels, tfEnabledMatch } = useApp();
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap', gap: '15px' }}>
        <div>
          <h2 style={{ margin: 0, color: '#0f2027' }}>
            Global Model Evaluation <span style={{ fontSize: '12px', backgroundColor: '#17a2b8', color: '#fff', padding: '3px 8px', borderRadius: '12px', verticalAlign: 'middle', marginLeft: '8px' }}>BETA</span>
          </h2>
          <p style={{ color: '#666', margin: '4px 0 0 0', fontSize: '13px' }}>Echostar Enterprise Architecture Model Governance & Benchmarking Engine</p>
        </div>

        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          {role === 'admin' && (
            <button
              onClick={handleEvaluateAllModels}
              disabled={loading}
              style={{ padding: '10px 18px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '20px', fontWeight: 'bold', cursor: 'pointer', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', fontSize: '13px' }}>
              ⚡ Evaluate All Models
            </button>
          )}

          {can('run_evaluation') && <BedrockAccessButton getAuthHeaders={getAuthHeaders} fetchCatalogs={fetchCatalogs} />}

          <div style={{ position: 'relative', minWidth: '260px' }}>
            <input
              type="text"
              placeholder="🔍 Search catalog models..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ width: '100%', padding: '10px 14px', fontSize: '13px', border: '2px solid #0073bb', borderRadius: '20px', outline: 'none' }}
            />
          </div>
        </div>
      </div>

      {/* PIPELINE: tabs follow the model lifecycle left-to-right.
          ① Market Scanner (discover) → ② Other Models (evaluate) → ③ EchoStar Approved
          (vetted record) → ④ TrueFoundry VM (what's actually serving) → ⑤ Challenger
          (models lined up to replace a VM incumbent, incl. the 4 self-hosted PoC).
          Utility tabs (incl. the VM push / A-B flip console) follow after the divider. */}
      <div style={{ fontSize: '11px', color: '#8a97a8', margin: '0 0 6px 2px', letterSpacing: '0.3px' }}>
        PIPELINE &nbsp;①&nbsp;Scan &nbsp;→&nbsp; ②&nbsp;All Models &nbsp;→&nbsp; ③&nbsp;Approved &nbsp;→&nbsp; ④&nbsp;TrueFoundry VM &nbsp;→&nbsp; ⑤&nbsp;Challenger
      </div>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '2px solid #cbd5e0', flexWrap: 'wrap', alignItems: 'center' }}>
        <button onClick={() => { setActiveTab('market-scan'); if(discoveredModels.length === 0) scanArtificialAnalysisMarket(); }} style={{ padding: '10px 15px', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold', borderBottom: activeTab === 'market-scan' ? '3px solid #0073bb' : 'none', color: activeTab === 'market-scan' ? '#0073bb' : '#4a5568' }}>
          ① Market Scanner 🌐 ({filteredDiscovered.length})
        </button>
        <span style={{ color: '#cbd5e0' }}>›</span>
        <button onClick={() => { setActiveTab('other'); fetchCatalogs(); }} style={{ padding: '10px 15px', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold', borderBottom: activeTab === 'other' ? '3px solid #ffc107' : 'none', color: activeTab === 'other' ? '#d39e00' : '#4a5568' }}>
          ② All Models ({filteredOther.length})
        </button>
        <span style={{ color: '#cbd5e0' }}>›</span>
        <button onClick={() => { setActiveTab('echostar'); fetchCatalogs(); }} style={{ padding: '10px 15px', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold', borderBottom: activeTab === 'echostar' ? '3px solid #28a745' : 'none', color: activeTab === 'echostar' ? '#28a745' : '#4a5568' }}>
          ③ EchoStar Approved ({filteredEchostar.length})
        </button>
        <span style={{ color: '#cbd5e0' }}>›</span>
        <button onClick={() => { setActiveTab('vm'); fetchCatalogs(); }} style={{ padding: '10px 15px', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold', borderBottom: activeTab === 'vm' ? '3px solid #17a2b8' : 'none', color: activeTab === 'vm' ? '#138496' : '#4a5568' }}>
          ④ TrueFoundry VM
        </button>
        <span style={{ color: '#cbd5e0' }}>›</span>
        <button onClick={() => { setActiveTab('challenger'); fetchCatalogs(); }} style={{ padding: '10px 15px', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold', borderBottom: activeTab === 'challenger' ? '3px solid #fd7e14' : 'none', color: activeTab === 'challenger' ? '#fd7e14' : '#4a5568' }}>
          ⑤ Challenger 🥊
        </button>

        {/* divider: analysis / utility tabs (not part of the linear pipeline) */}
        <span style={{ width: '1px', alignSelf: 'stretch', background: '#cbd5e0', margin: '0 4px' }} />
        <button onClick={() => setActiveTab('model-search')} title="Find any model (registries + internet) and add it to All Models" style={{ padding: '10px 15px', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold', borderBottom: activeTab === 'model-search' ? '3px solid #0f5c55' : 'none', color: activeTab === 'model-search' ? '#0f5c55' : '#4a5568' }}>
          🔎 Find a Model
        </button>
        <button onClick={() => { setActiveTab('compare'); fetchCatalogs(); }} style={{ padding: '10px 15px', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold', borderBottom: activeTab === 'compare' ? '3px solid #6f42c1' : 'none', color: activeTab === 'compare' ? '#6f42c1' : '#4a5568' }}>
          ⚖️ Compare
        </button>
        <button onClick={() => setActiveTab('criteria')} style={{ padding: '10px 15px', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold', borderBottom: activeTab === 'criteria' ? '3px solid #6f42c1' : 'none', color: activeTab === 'criteria' ? '#6f42c1' : '#4a5568' }}>
          📐 Selection Criteria
        </button>
        <button onClick={() => setActiveTab('prescreen')} title="Every rule behind the AI Office signals: origin, platform, Legal, TPRM, Security, score bar" style={{ padding: '10px 15px', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold', borderBottom: activeTab === 'prescreen' ? '3px solid #6f42c1' : 'none', color: activeTab === 'prescreen' ? '#6f42c1' : '#4a5568' }}>
          🛡️ AI Office Rules
        </button>
        <button onClick={() => { setActiveTab('suites'); fetchSuitesCatalog(); }} style={{ padding: '10px 15px', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold', borderBottom: activeTab === 'suites' ? '3px solid #17a2b8' : 'none', color: activeTab === 'suites' ? '#17a2b8' : '#4a5568' }}>
          Test Suites ({suitesCatalog.length})
        </button>
        <button onClick={() => setActiveTab('eval-trace')} style={{ padding: '10px 15px', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold', borderBottom: activeTab === 'eval-trace' ? '3px solid #0073bb' : 'none', color: activeTab === 'eval-trace' ? '#0073bb' : '#4a5568' }}>
          Single Evaluator & Trace
        </button>
        <button onClick={() => setActiveTab('logs')} style={{ padding: '10px 15px', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold', borderBottom: activeTab === 'logs' ? '3px solid #dc3545' : 'none', color: activeTab === 'logs' ? '#dc3545' : '#4a5568' }}>
          📜 System Logs
        </button>
      </div>

      {statusMsg && <p style={{ backgroundColor: '#eef3f8', padding: '10px', borderRadius: '4px', color: '#004085', fontSize: '13px' }}>{statusMsg}</p>}

      {batchResult && (
        <div style={{
          border: `2px solid ${batchResult.reconciled ? '#28a745' : '#dc3545'}`,
          backgroundColor: batchResult.reconciled ? '#f0fff4' : '#fff5f5',
          borderRadius: '8px', padding: '14px', marginBottom: '15px'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <strong style={{ color: batchResult.reconciled ? '#22543d' : '#742a2a', fontSize: '14px' }}>
              {batchResult.reconciled ? '✅ Batch Evaluation Verified Complete' : '⚠️ Batch Completed — Verification Mismatch'}
            </strong>
            <span style={{ fontSize: '11px', color: '#555' }}>batch id: {batchResult.batch_id}</span>
            <button onClick={() => setBatchResult(null)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '14px', color: '#888' }}>✕</button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '8px', fontSize: '12px' }}>
            <div>Total models: <strong>{batchResult.total_models}</strong></div>
            <div>Evaluated (server): <strong>{batchResult.evaluated_count}</strong></div>
            <div>Failed: <strong style={{ color: batchResult.failed_count ? '#c53030' : '#22543d' }}>{batchResult.failed_count}</strong></div>
            <div>Scorecards persisted (verified): <strong>{batchResult.verified_total}</strong></div>
          </div>
          <div style={{ marginTop: '8px', fontSize: '12px', color: batchResult.reconciled ? '#22543d' : '#742a2a' }}>
            {batchResult.reconciled
              ? `Re-fetched catalog confirms ${batchResult.verified_total} models now carry real scorecards. Server report reconciles with persisted data.`
              : `Server reported ${batchResult.evaluated_count} evaluated but only ${batchResult.verified_total} verified in the re-fetched catalog. Some writes may not have persisted — re-run or check the System Logs tab.`}
          </div>
          {batchResult.failed_count > 0 && (
            <details style={{ marginTop: '8px', fontSize: '11px' }}>
              <summary style={{ cursor: 'pointer', color: '#c53030', fontWeight: 'bold' }}>
                View {batchResult.failed_count} failed model(s)
              </summary>
              <ul style={{ margin: '6px 0 0 18px' }}>
                {(batchResult.failed_models || []).map((f, i) => (
                  <li key={i}><strong>{f.model_id}</strong>: {f.error}</li>
                ))}
              </ul>
            </details>
          )}
        </div>
      )}

      {activeTab === 'echostar' && (
        <div>
          <h3>EchoStar Approved Models & Assigned Virtual Tags</h3>
          {renderModelTable(filteredEchostar, false)}
        </div>
      )}

      {activeTab === 'vm' && <VmMembersPanel />}

      {activeTab === 'challenger' && <ChallengerArena />}

      {activeTab === 'other' && (
        <div>
          <h3>All Models — full discovered catalog & recommended virtual categories</h3>
          {renderModelTable(filteredOther, true)}
        </div>
      )}

      {activeTab === 'prescreen' && <PrescreenRulesTab getAuthHeaders={getAuthHeaders} />}

      {activeTab === 'model-search' && <ModelSearchTab getAuthHeaders={getAuthHeaders} fetchCatalogs={fetchCatalogs} />}

      {activeTab === 'criteria' && (
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '8px', border: '1px solid #ddd' }}>
          <h3>📐 EEA TrueFoundry Virtual Model Selection Criteria Matrix</h3>
          
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px', fontSize: '12px' }}>
            <thead>
              <tr style={{ backgroundColor: '#f0f4f8', borderBottom: '2px solid #ccc', textAlign: 'left' }}>
                <th style={{ padding: '10px' }}>Virtual Alias Category</th>
                <th style={{ padding: '10px' }}>Target SLA / Benchmark Metrics Required</th>
                <th style={{ padding: '10px' }}>Recommended Primary Backends</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '10px' }}><strong style={{ color: '#0073bb' }}>echostar/fast-v1</strong></td>
                <td style={{ padding: '10px' }}>
                  • Latency P95 &lt; 300ms<br/>
                  • Token Cost &lt; $1.00 / 1M<br/>
                  • Safety Pass Rate &ge; 98.0%<br/>
                  • High throughput intent classification & chat lookup
                </td>
                <td style={{ padding: '10px' }}>• Claude 3.5 Haiku (Bedrock)<br/>• Amazon Nova Lite<br/>• Google Gemma 4 31B (Self-Hosted)</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '10px' }}><strong style={{ color: '#28a745' }}>echostar/smart-v1</strong></td>
                <td style={{ padding: '10px' }}>
                  • Golden Suite &ge; 82%<br/>
                  • DS1000 &gt; 80% | MT-Bench &gt; 8.5<br/>
                  • Latency P95 &lt; 500ms<br/>
                  • Core enterprise agent execution & structured JSON
                </td>
                <td style={{ padding: '10px' }}>• Claude 3.5 Sonnet (Bedrock)<br/>• Amazon Nova Pro<br/>• Meta Llama 3.3 70B (Self-Hosted vLLM)</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '10px' }}><strong style={{ color: '#6f42c1' }}>echostar/balanced-v1</strong></td>
                <td style={{ padding: '10px' }}>
                  • Golden Suite &ge; 90%<br/>
                  • Berkeley BFCL &gt; 90% | CRAG &gt; 75%<br/>
                  • RULER / FRAMES multi-hop reasoning & complex coding
                </td>
                <td style={{ padding: '10px' }}>• Claude 3.7 Sonnet (Bedrock)<br/>• OpenAI GPT-6 Luna / GPT-5.3</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {activeTab === 'approved-cat' && (
        <div>
          <h3 style={{ marginBottom: '4px' }}>✅ Approved Models by Virtual Category</h3>
          <p style={{ color: '#666', fontSize: '13px', marginTop: 0 }}>
            EchoStar-approved models grouped by their assigned TrueFoundry virtual alias.
            Promoting only approves a model. Nothing is added to TrueFoundry until you click <strong>Push</strong> for <strong>sandbox</strong>, <strong>np</strong> or <strong>prod</strong>. Pick a role and weight before pushing. Push a model as a <strong>Challenger</strong> (0%), then use <strong>A/B flip</strong> to ramp it 10 → 50 → 100% against the primary, with rollback. Click <strong>Compare</strong> at each stage to test both models on your test-suite prompts before moving on.
          </p>
          {(() => {
            const approved = echostarCatalog;
            const vmOf = (it) => (it.assigned_virtual_model || (it.virtual_model_recommendation || {}).recommended_vm || '').toLowerCase();
            const buckets = {
              'echostar/fast-v1':     approved.filter(i => vmOf(i).includes('fast')),
              'echostar/smart-v1':    approved.filter(i => vmOf(i).includes('smart') || (!vmOf(i).includes('fast') && !vmOf(i).includes('balanced') && !vmOf(i).includes('advanced'))),
              'echostar/balanced-v1': approved.filter(i => vmOf(i).includes('balanced') || vmOf(i).includes('advanced')),
            };
            const selfHosted = approved.filter(isSelfHostableModel);

            const meta = {
              'echostar/fast-v1':     { color: '#0073bb', label: 'FAST', blurb: 'Low latency / high throughput' },
              'echostar/smart-v1':    { color: '#28a745', label: 'SMART', blurb: 'Core enterprise agent execution' },
              'echostar/balanced-v1': { color: '#6f42c1', label: 'BALANCED', blurb: 'Deep reasoning & complex coding' },
            };

            const ROLE_COLORS = { primary: '#155724', challenger: '#b35c00', fallback: '#495057', cost: '#0d47a1' };
            // Complexity-based (tiered) VMs route by tier, not %. Today that is the balanced VM.
            const isTiered = (v) => v.includes('balanced') || v.includes('advanced');

            const card = (item) => {
              const mId = item.model_id || item.id;
              const recVm = item.assigned_virtual_model || (item.virtual_model_recommendation || {}).recommended_vm || 'echostar/smart-v1';
              const vm = pushVmPick[mId] || recVm;
              const opts = pushOpts[mId] || {};
              const setOpt = (k, val) => setPushOpts(prev => ({ ...prev, [mId]: { ...(prev[mId] || {}), [k]: val } }));
              const placements = item.vm_placements || {};
              const flips = item.ab_flip || {};
              const tiered = isTiered(vm);
              const small = { padding: '3px 7px', fontSize: '10px', border: 'none', color: '#fff', borderRadius: '3px', cursor: 'pointer' };
              return (
                <div key={mId} style={{ border: '1px solid #e2e8f0', borderRadius: '6px', padding: '10px 12px', marginBottom: '8px', background: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                  <div style={{ minWidth: '220px' }}>
                    <div style={{ fontWeight: 'bold', fontSize: '13px', wordBreak: 'break-all' }}>{mId}</div>
                    <div style={{ fontSize: '11px', color: '#666' }}>
                      {item.architecture_type || 'Frontier Proprietary'} · Golden {((item.scorecard || {}).evaluation_mode === 'LIVE' && (item.scorecard || {}).golden_suite_benchmark_score != null) ? `${(item.scorecard || {}).golden_suite_benchmark_score}%` : 'not evaluated'}
                      · {fmtCostPerMCell(item)}/1M
                    </div>
                    {Object.keys(placements).length > 0 && (
                      <div style={{ fontSize: '10px', marginTop: '3px', display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                        {Object.entries(placements).map(([env, p]) => (
                          <span key={env} style={{ border: `1px solid ${ROLE_COLORS[p.role] || '#999'}`, color: ROLE_COLORS[p.role] || '#555', borderRadius: '3px', padding: '1px 5px' }}>
                            {env}: {p.role || 'primary'}{p.tier ? ` · ${p.tier}` : (p.weight !== undefined && p.weight !== null ? ` · ${p.weight}%` : '')}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                  {can('push_truefoundry') && (
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', fontSize: '10px', color: '#555', gap: '3px' }}>
                        <span style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>Target VM</span>
                        <select value={vm} onChange={(e) => setPushVmPick(prev => ({ ...prev, [mId]: e.target.value }))}
                                title="Virtual model that Push/Pull will act on"
                                style={{ fontSize: '11px', padding: '3px' }}>
                          {Object.keys(meta).map(k => (
                            <option key={k} value={k}>{k}{k === recVm ? ' (current)' : ''}</option>
                          ))}
                          {!meta[recVm] && <option value={recVm}>{recVm} (current)</option>}
                        </select>
                        <div style={{ display: 'flex', gap: '4px' }}>
                          <select value={opts.role || 'primary'} onChange={(e) => setOpt('role', e.target.value)} title="Role in this VM"
                                  style={{ fontSize: '11px', padding: '3px' }}>
                            <option value="primary">Primary</option>
                            <option value="challenger">Challenger</option>
                            <option value="fallback">Fallback</option>
                            <option value="cost">Cost option</option>
                          </select>
                          {tiered ? (
                            <select value={opts.tier || 'medium'} onChange={(e) => setOpt('tier', e.target.value)} title="Tier (complexity-based VM)"
                                    style={{ fontSize: '11px', padding: '3px' }}>
                              <option value="simple">Simple</option>
                              <option value="medium">Medium</option>
                              <option value="complex">Complex</option>
                            </select>
                          ) : (
                            <input type="number" min="0" max="100" placeholder={opts.role === 'fallback' ? '0' : opts.role === 'challenger' ? '0' : 'auto'}
                                   value={opts.weight ?? ''} onChange={(e) => setOpt('weight', e.target.value)}
                                   title="Traffic weight % for this model. Others are scaled to fill the rest. Blank = equal share (fallback/challenger = 0)."
                                   style={{ width: '52px', fontSize: '11px', padding: '3px' }} />
                          )}
                        </div>
                      </div>
                      {['sandbox', 'np', 'prod'].map(env => {
                        const key = `${mId}::${env}`;
                        const st = vmStatus[key];
                        const busy = st === 'pushing' || st === 'pulling' || st === 'flipping';
                        const flip = flips[env];
                        const placed = placements[env];
                        // Challengers default to 0% so the flip controls the ramp.
                        const pushOpts_ = { role: opts.role || 'primary', tier: tiered ? (opts.tier || 'medium') : undefined,
                                            weight: tiered ? undefined : (opts.weight !== undefined && opts.weight !== '' ? opts.weight
                                                    : (opts.role === 'challenger' ? 0 : undefined)) };
                        return (
                          <div key={env} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', border: `1px solid ${flip ? '#fd7e14' : '#e2e8f0'}`, borderRadius: '6px', padding: '4px 6px' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#555', textTransform: 'uppercase' }}>{env}</span>
                            <div style={{ display: 'flex', gap: '3px', marginTop: '2px' }}>
                              <button onClick={() => handleVmPush(mId, vm, env, pushOpts_)} disabled={busy || !!flip} title={flip ? 'Flip in progress' : `Push into ${vm} (${env})`}
                                style={{ ...small, background: '#28a745' }}>Push</button>
                              <button onClick={() => handleVmPull(mId, vm, env)} disabled={busy || !!flip} title={flip ? 'Flip in progress' : `Remove from ${vm} (${env})`}
                                style={{ ...small, background: '#dc3545' }}>Pull</button>
                            </div>
                            {!tiered && !flip && placed && placed.role === 'challenger' && placed.vm === vm && (
                              <button onClick={() => handleVmFlip(mId, env, 'start', vm)} disabled={busy} title="Start A/B flip at 10% vs the current primary"
                                style={{ ...small, background: '#fd7e14', marginTop: '3px' }}>A/B flip</button>
                            )}
                            {flip && (
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '3px', gap: '2px' }}>
                                <span style={{ fontSize: '9px', color: '#b35c00' }}>A/B {flip.stage}% vs {flip.incumbent}</span>
                                <div style={{ display: 'flex', gap: '3px' }}>
                                  {Number(flip.stage) < 100
                                    ? <button onClick={() => handleVmFlip(mId, env, 'advance')} disabled={busy} title="Ramp 10 → 50 → 100%" style={{ ...small, background: '#0073bb' }}>Next ▶</button>
                                    : <button onClick={() => handleVmFlip(mId, env, 'complete')} disabled={busy} title="Make this the primary" style={{ ...small, background: '#155724' }}>Complete</button>}
                                  <button onClick={() => handleVmFlip(mId, env, 'rollback')} disabled={busy} title="Restore weights from before the flip" style={{ ...small, background: '#6c757d' }}>Rollback</button>
                                </div>
                                <button onClick={() => handleVmFlip(mId, env, 'compare')} disabled={busy} title="Send test-suite prompts to both models and compare"
                                  style={{ ...small, background: '#6f42c1' }}>Compare</button>
                                {(() => {
                                  const last = (flip.comparisons || []).slice(-1)[0];
                                  if (!last) return <span style={{ fontSize: '9px', color: '#888' }}>Not compared yet at this stage</span>;
                                  const c = last.challenger || {}, i = last.incumbent || {};
                                  const v = (last.verdict || {}).verdict;
                                  const h = last.head_to_head || {};
                                  const fmt = (x, s = '') => (x === null || x === undefined ? '—' : `${x}${s}`);
                                  const rows = [
                                    ['Quality win', h.win_rate != null ? `${h.win_rate}%` : '—', '—', h.win_rate != null && h.win_rate >= 50],
                                    ['Quality', fmt(c.quality), fmt(i.quality), c.quality != null && i.quality != null && c.quality >= i.quality],
                                    ['P95 ms', fmt(c.p95_latency_ms), fmt(i.p95_latency_ms), c.p95_latency_ms && i.p95_latency_ms && c.p95_latency_ms <= i.p95_latency_ms],
                                    ['Errors', fmt(c.error_rate, '%'), fmt(i.error_rate, '%'), (c.error_rate || 0) <= (i.error_rate || 0)],
                                    ['$/req', fmt(c.cost_per_request_usd), fmt(i.cost_per_request_usd), c.cost_per_request_usd != null && i.cost_per_request_usd != null && c.cost_per_request_usd <= i.cost_per_request_usd],
                                  ];
                                  return (
                                    <div title={((last.verdict || {}).reasons || []).join('\n')}
                                         style={{ fontSize: '9px', border: `1px solid ${v === 'PROCEED' ? '#28a745' : '#dc3545'}`, borderRadius: '4px', padding: '3px 4px', marginTop: '2px' }}>
                                      <div style={{ fontWeight: 'bold', color: v === 'PROCEED' ? '#155724' : '#b00020' }}>
                                        {v === 'PROCEED' ? '✔ Proceed' : '✖ Roll back'} · at {last.stage}% · {c.requests} prompts
                                      </div>
                                      <table style={{ borderCollapse: 'collapse' }}>
                                        <thead><tr><th></th><th style={{ padding: '0 3px' }}>Chal.</th><th style={{ padding: '0 3px' }}>Prim.</th></tr></thead>
                                        <tbody>{rows.map(([k, a, b, good]) => (
                                          <tr key={k}><td>{k}</td>
                                            <td style={{ padding: '0 3px', textAlign: 'right', color: good ? '#155724' : '#b00020' }}>{a}</td>
                                            <td style={{ padding: '0 3px', textAlign: 'right' }}>{b}</td></tr>
                                        ))}</tbody>
                                      </table>
                                    </div>
                                  );
                                })()}
                              </div>
                            )}
                            {st && (
                              <span style={{ fontSize: '9px', marginTop: '2px',
                                color: st === 'SUCCESS' ? '#155724' : st === 'REMOVED' ? '#842029' : st === 'ERROR' ? '#b00020' : '#666' }}>
                                {busy ? '…' : st}
                              </span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            };

            return (
              <div>
                {Object.keys(meta).map(vmKey => (
                  <div key={vmKey} style={{ marginBottom: '18px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                      <span style={{ background: meta[vmKey].color, color: '#fff', borderRadius: '4px', padding: '3px 10px', fontSize: '12px', fontWeight: 'bold' }}>
                        {meta[vmKey].label}
                      </span>
                      <strong style={{ fontSize: '13px' }}>{vmKey}</strong>
                      <span style={{ color: '#888', fontSize: '11px' }}>{meta[vmKey].blurb}</span>
                      <span style={{ color: '#aaa', fontSize: '11px' }}>({buckets[vmKey].length})</span>
                    </div>
                    {buckets[vmKey].length === 0
                      ? <div style={{ color: '#bbb', fontSize: '12px', padding: '4px 2px' }}>No approved models in this category yet.</div>
                      : buckets[vmKey].map(card)}
                  </div>
                ))}

                <div style={{ marginTop: '10px', borderTop: '2px dashed #cbd5e0', paddingTop: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                    <span style={{ background: '#17a2b8', color: '#fff', borderRadius: '4px', padding: '3px 10px', fontSize: '12px', fontWeight: 'bold' }}>SELF-HOSTED</span>
                    <strong style={{ fontSize: '13px' }}>Open-Weights / Self-Hostable (vLLM / Artifactory)</strong>
                    <span style={{ color: '#aaa', fontSize: '11px' }}>({selfHosted.length})</span>
                  </div>
                  {selfHosted.length === 0
                    ? <div style={{ color: '#bbb', fontSize: '12px' }}>No self-hosted approved models yet.</div>
                    : selfHosted.map(card)}
                </div>
              </div>
            );
          })()}
        </div>
      )}

      {activeTab === 'market-scan' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
            <h3>Artificial Analysis & Global Registries Releases Scanner (20 Live Models)</h3>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <label style={{ fontSize: '12px', color: '#4a5568' }}>New within:</label>
              <select value={marketScanDays} disabled={loading}
                onChange={e => { const d = parseInt(e.target.value, 10); setMarketScanDays(d); scanArtificialAnalysisMarket(d); }}
                style={{ padding: '7px', fontSize: '12px', border: '1px solid #ccc', borderRadius: '4px', cursor: 'pointer' }}>
                <option value={1}>1 day</option>
                <option value={2}>2 days</option>
                <option value={3}>3 days</option>
                <option value={7}>1 week</option>
              </select>
              <button onClick={() => scanArtificialAnalysisMarket()} disabled={loading} style={{ padding: '8px 14px', cursor: 'pointer' }}>Scan Global Registries</button>
              <button onClick={() => pullTruefoundryModels()} style={{ padding: '8px 14px', cursor: 'pointer' }}
                      title="Pull the models enabled in the TrueFoundry sandbox and mark matches below">⟳ Pull TrueFoundry</button>
            </div>
          </div>

          <div style={{ fontSize: '11px', color: '#4a5568', marginBottom: '10px' }}>
            <span style={{ color: '#155724', fontWeight: 'bold' }}>✅ In TrueFoundry sandbox</span> marks a scanned model whose name already matches an enabled model in the TrueFoundry sandbox.
            {tfEnabled.length > 0 && <> {' '}<strong>{tfEnabled.length}</strong> enabled{tfPulledAt ? ` · pulled ${new Date(tfPulledAt).toLocaleTimeString()}` : ''}.</>}
            {tfEnabled.length === 0 && <> {' '}<em>No TrueFoundry models pulled yet.</em></>}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '15px' }}>
            {filteredDiscovered.map((item, idx) => {
              const gov = getGovernanceAnalysis(item);
              // Support BOTH the live OpenRouter payload and the static seed shape.
              const mId = item.id || item.model_id;
              const sc = item.scorecard || {};
              const released = item.createdAt || item.release_date || '—';
              const quality = item.aa_index != null ? item.aa_index : sc.public_benchmark_score;
              const latency = item.latency != null ? item.latency : sc.p95_latency_ms;
              const pricing = item.pricing != null ? item.pricing : sc.blended_usd_per_1m;
              const qSim = sc.quality_simulated === true;
              const tier = item.tier_category;
              const note = item.notable_note;
              return (
                <div key={idx} style={{ border: `2px solid ${gov.badgeColor}`, borderRadius: '8px', padding: '15px', backgroundColor: '#fafafa' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <span style={{ fontSize: '11px', color: '#0073bb', fontWeight: 'bold' }}>Source: {item.source}</span>
                    <span style={{ fontSize: '11px', color: '#555', fontWeight: 'bold' }}>📅 Released: {released}</span>
                  </div>
                  <h4 style={{ margin: '0 0 6px 0', fontSize: '14px', wordBreak: 'break-all' }}>{mId}</h4>
                  {(() => {
                    const tfHit = tfEnabledMatch(mId);
                    return tfHit ? (
                      <div title={`Enabled in TrueFoundry sandbox as ${tfHit}`}
                           style={{ display: 'inline-block', padding: '2px 8px', borderRadius: '10px', fontSize: '10px', fontWeight: 'bold',
                                    backgroundColor: '#d4edda', color: '#155724', border: '1px solid #b7dfc3', marginBottom: '6px' }}>
                        ✅ In TrueFoundry sandbox
                      </div>
                    ) : null;
                  })()}
                  {tier && (
                    <span style={{ display: 'inline-block', padding: '2px 8px', borderRadius: '10px', fontSize: '10px', fontWeight: 'bold', marginBottom: '6px',
                                   backgroundColor: tier.includes('1') ? '#ede7ff' : tier.includes('2') ? '#e0f2e9' : '#ffeedd',
                                   color: tier.includes('1') ? '#5b34c7' : tier.includes('2') ? '#1b7a4b' : '#9a5a1b' }}>
                      {tier.includes('1') ? 'Tier 1 · Frontier' : tier.includes('2') ? 'Tier 2 · SLM' : 'Tier 3 · Domain'}
                    </span>
                  )}
                  <div style={{ fontSize: '11px', fontWeight: 'bold', color: gov.badgeColor, marginBottom: '6px' }}>
                    POLICY STATUS: {gov.statusLabel}
                  </div>
                  <p style={{ fontSize: '12px', margin: '4px 0' }}>
                    Quality: <strong>{quality != null ? quality : '—'}</strong>{qSim && <span title="Simulated estimate, not a measured benchmark" style={{ color: '#9a5a1b', fontSize: '10px' }}> (sim)</span>}
                    {latency != null && <> | Latency: <strong>{latency}ms</strong></>}
                    {pricing != null && <> | Cost: <strong>${pricing}/1M</strong></>}
                  </p>
                  {note && (
                    <p style={{ fontSize: '11px', margin: '6px 0', color: '#444', fontStyle: 'italic', lineHeight: 1.4 }}>
                      💡 {note}
                    </p>
                  )}
                  {role === 'admin' && (
                    <button
                      onClick={() => handleImportAndEvaluateFromMarket(mId, released)}
                      disabled={loading}
                      style={{ width: '100%', padding: '8px', backgroundColor: '#0073bb', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '12px', marginTop: '8px' }}>
                      📥 Import to All Models & Evaluate
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {activeTab === 'suites' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap', gap: '8px' }}>
            <h3>Test Suites Catalog</h3>
            {role === 'admin' && (
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'flex-end', flex: 1 }}>
              <SuiteImport headers={getAuthHeaders} onImported={() => fetchSuitesCatalog()} />
              <button
                onClick={() => setShowAddSuiteModal(true)}
                style={{ padding: '8px 16px', backgroundColor: '#17a2b8', color: '#fff', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px' }}>
                ➕ Add Golden Test Suite
              </button>
              </div>
            )}
          </div>

          {showAddSuiteModal && (
            <div style={{ backgroundColor: '#fff', border: '2px solid #17a2b8', borderRadius: '8px', padding: '20px', marginBottom: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
              <h4 style={{ marginTop: 0, color: '#17a2b8' }}>Add New Golden Test Suite</h4>
              <form onSubmit={handleAddGoldenSuite}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
                  <div>
                    <label style={{ display: 'block', fontSize: '11px', fontWeight: 'bold', marginBottom: '4px' }}>Suite ID</label>
                    <input
                      type="text"
                      placeholder="e.g. Golden_Suite_v2"
                      value={newSuiteData.suite_id}
                      onChange={(e) => setNewSuiteData({ ...newSuiteData, suite_id: e.target.value })}
                      required
                      style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: '11px', fontWeight: 'bold', marginBottom: '4px' }}>Version</label>
                    <input
                      type="text"
                      placeholder="e.g. 1.0"
                      value={newSuiteData.version}
                      onChange={(e) => setNewSuiteData({ ...newSuiteData, version: e.target.value })}
                      required
                      style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
                    />
                  </div>
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <label style={{ display: 'block', fontSize: '11px', fontWeight: 'bold', marginBottom: '4px' }}>Evaluation Prompt</label>
                  <textarea
                    placeholder="Enter test prompt for evaluation..."
                    value={newSuiteData.prompt}
                    onChange={(e) => setNewSuiteData({ ...newSuiteData, prompt: e.target.value })}
                    required
                    style={{ width: '100%', height: '60px', padding: '8px', boxSizing: 'border-box' }}
                  />
                </div>
                <div style={{ marginBottom: '15px' }}>
                  <label style={{ display: 'block', fontSize: '11px', fontWeight: 'bold', marginBottom: '4px' }}>Expected Output / Ground Truth</label>
                  <textarea
                    placeholder="Enter expected answer or evaluation criteria..."
                    value={newSuiteData.expected_output}
                    onChange={(e) => setNewSuiteData({ ...newSuiteData, expected_output: e.target.value })}
                    required
                    style={{ width: '100%', height: '60px', padding: '8px', boxSizing: 'border-box' }}
                  />
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button type="submit" disabled={loading} style={{ padding: '8px 16px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>Save Suite</button>
                  <button type="button" onClick={() => setShowAddSuiteModal(false)} style={{ padding: '8px 16px', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Cancel</button>
                </div>
              </form>
            </div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {(() => {
              // Group the flat per-prompt rows into ONE card per suite (suite_group),
              // so a JSON suite is a single unit you can add or remove as a whole.
              const groups = {};
              (filteredSuites || []).forEach(row => {
                const g = row.suite_group || row.suite_id || 'Golden Test Suite';
                if (!groups[g]) groups[g] = [];
                groups[g].push(row);
              });
              const names = Object.keys(groups).sort();
              if (names.length === 0) return <div style={{ color: '#888', fontSize: '13px' }}>No test suites yet. Add one or import a JSON suite above.</div>;
              return names.map((g, gi) => {
                const items = groups[g];
                const ver = (items[0] || {}).version;
                const cat = (items[0] || {}).category;
                return (
                  <div key={gi} style={{ border: '1px solid #ccc', borderRadius: '8px', padding: '12px 15px', backgroundColor: '#fff' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                      <h4 style={{ margin: 0, color: '#0073bb', fontSize: '14px' }}>
                        {g} <span style={{ fontSize: '11px', color: '#718096', fontWeight: 'normal' }}>· {items.length} prompt{items.length === 1 ? '' : 's'}{ver ? ` · v${ver}` : ''}</span>
                        {cat && <span style={{ marginLeft: '8px', fontSize: '10px', background: '#eef6fc', color: '#0073bb', padding: '2px 6px', borderRadius: '8px' }}>{cat}</span>}
                      </h4>
                      {role === 'admin' && (
                        <button onClick={() => { if (window.confirm(`Delete the entire suite "${g}" and all ${items.length} prompt(s)? This cannot be undone.`)) deleteSuite(g); }}
                                disabled={loading}
                                style={{ padding: '5px 10px', fontSize: '11px', border: '1px solid #e53e3e', background: '#fff5f5', color: '#c53030', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
                          🗑 Delete Suite
                        </button>
                      )}
                    </div>
                    <details>
                      <summary style={{ cursor: 'pointer', fontSize: '12px', color: '#555' }}>View {items.length} prompt{items.length === 1 ? '' : 's'}</summary>
                      <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {items.map((suite, idx) => (
                          <div key={idx} style={{ borderLeft: '3px solid #e2e8f0', padding: '4px 10px' }}>
                            <div style={{ fontSize: '11px', color: '#718096', marginBottom: '2px' }}>
                              {suite.item_id || `#${idx + 1}`}
                              {suite.status && suite.status !== 'ACTIVE' && <span style={{ marginLeft: '6px', color: '#b00020' }}>{suite.status}</span>}
                            </div>
                            <p style={{ fontSize: '12px', margin: '2px 0' }}><strong>Prompt:</strong> {suite.prompt || '—'}</p>
                            <p style={{ fontSize: '12px', margin: '2px 0', color: '#555' }}><strong>Expected:</strong> {suite.expected_output || '—'}</p>
                          </div>
                        ))}
                      </div>
                    </details>
                  </div>
                );
              });
            })()}
          </div>
        </div>
      )}

      {activeTab === 'eval-trace' && (
        <div>
          <h3>Single Model Evaluator & Live Communication Trace</h3>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
            <input
              type="text"
              value={modelId}
              onChange={(e) => setModelId(e.target.value)}
              placeholder="Enter model string..."
              style={{ flex: 1, padding: '10px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '4px' }}
            />
            <button onClick={() => handleRunEvaluation()} disabled={loading || role !== 'admin'} style={{ padding: '10px 15px', backgroundColor: role === 'admin' ? '#0073bb' : '#ccc', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
              Run Golden Suite Evaluation
            </button>
          </div>

          {agentLogs.length > 0 && (
            <div style={{ backgroundColor: '#1e1e1e', color: '#00ff66', padding: '15px', borderRadius: '8px', fontFamily: 'Consolas, monospace', marginBottom: '20px' }}>
              <h4 style={{ margin: '0 0 10px 0', color: '#fff' }}>🤖 Live Agent Communication Trace</h4>
              {agentLogs.map((log, i) => (
                <div key={i} style={{ fontSize: '13px', marginBottom: '4px' }}>
                  <span style={{ color: '#00bfff' }}>[{log.agent}]:</span> {log.action}
                </div>
              ))}
            </div>
          )}

          {scorecard && (
            <div style={{ marginTop: '20px' }}>
              {renderModelScorecard(scorecard, scorecard.compliance_status !== "ECHOSTAR_APPROVED")}
            </div>
          )}
        </div>
      )}

      {activeTab === 'logs' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
            <h3>📜 System & Component Logs Inspector</h3>
            <div style={{ display: 'flex', gap: '10px' }}>
              <select
                value={selectedLogComponent}
                onChange={(e) => setSelectedLogComponent(e.target.value)}
                style={{ padding: '8px', fontSize: '13px', borderRadius: '4px' }}>
                <option value="backend">Gunicorn / Flask Backend Logs</option>
                <option value="nginx">Nginx Web Server Logs</option>
                <option value="dynamodb">DynamoDB Scorecard Stream</option>
              </select>
              <button
                onClick={() => fetchSystemLogs(selectedLogComponent)}
                disabled={loading}
                style={{ padding: '8px 14px', backgroundColor: '#0073bb', color: '#fff', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}>
                🔄 Refresh Logs
              </button>
            </div>
          </div>

          <div style={{ backgroundColor: '#1e1e1e', color: '#f8f9fa', padding: '15px', borderRadius: '8px', fontFamily: 'Consolas, monospace', height: '420px', overflowY: 'auto', fontSize: '12px', border: '1px solid #333' }}>
            {fetchedLogs.length > 0 ? (
              fetchedLogs.map((line, idx) => (
                <div key={idx} style={{ marginBottom: '3px', whiteSpace: 'pre-wrap', color: line.includes('ERROR') ? '#ff6b6b' : line.includes('WARN') ? '#ffd166' : '#a8ffb2' }}>
                  {line}
                </div>
              ))
            ) : (
              <div style={{ color: '#888' }}>Loading component logs...</div>
            )}
          </div>
        </div>
      )}

      {activeTab === 'compare' && (
        <ModelComparePanel getAuthHeaders={getAuthHeaders} echostarCatalog={echostarCatalog} otherCatalog={otherCatalog} discoveredModels={discoveredModels} />
      )}
    </div>
  );
}

// 🔐 Check Bedrock access — calls every active Bedrock text model once (1 token) as the
// backend's own AWS role, then marks each catalog model "Bedrock available" or what
// blocks it (SCP / IAM / model access). Uses the same background-job polling as Evaluate.
const BEDROCK_LABELS = { ALLOWED: 'available', SCP_DENY: 'blocked by SCP', RCP_DENY: 'blocked by RCP', IAM_DENY: 'blocked by IAM',
  BOUNDARY_DENY: 'blocked by permissions boundary', SESSION_POLICY_DENY: 'blocked by session policy', NO_MODEL_ACCESS: 'access not granted', USE_CASE_FORM: 'Anthropic use case form needed',
  NEEDS_PROFILE: 'needs inference profile', NOT_FOUND: 'not in region', ERROR: 'check failed', SKIPPED: 'not on-demand' };

function BedrockAccessButton({ getAuthHeaders, fetchCatalogs }) {
  const [busy, setBusy] = React.useState(false);
  const [msg, setMsg] = React.useState('');
  const [summary, setSummary] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    fetch('/api/bedrock-access', { headers: getAuthHeaders() })
      .then(r => r.json()).then(d => setSummary(d && d.summary ? d.summary : null)).catch(() => {});
  }, []);

  const run = async () => {
    setBusy(true); setMsg('Starting Bedrock access check…'); setOpen(true);
    try {
      const r = await fetch('/api/bedrock-access-check', { method: 'POST', headers: getAuthHeaders(), body: JSON.stringify({}) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.job_id) throw new Error(d.error || `HTTP ${r.status}`);
      for (let i = 0; i < 180; i++) {
        await new Promise(res => setTimeout(res, 2000));
        const jr = await fetch(`/api/evaluate-live/${d.job_id}`, { headers: getAuthHeaders() });
        const job = await jr.json().catch(() => ({}));
        const last = (job.events || []).slice(-1)[0];
        if (last) setMsg(last.text);
        if (job.status === 'DONE') { setSummary((job.result || {}).summary || null); fetchCatalogs(); setMsg(''); break; }
        if (job.status === 'FAILED') throw new Error(job.error || 'check failed');
      }
    } catch (e) { setMsg(`Bedrock access check failed: ${e.message}`); }
    setBusy(false);
  };

  const c = (summary && summary.counts) || {};
  const blocked = ['SCP_DENY', 'RCP_DENY', 'IAM_DENY', 'BOUNDARY_DENY', 'SESSION_POLICY_DENY', 'NO_MODEL_ACCESS', 'USE_CASE_FORM'].reduce((n, k) => n + (c[k] || 0), 0);
  return (
    <div style={{ position: 'relative' }}>
      <button onClick={run} disabled={busy}
              title="Call every Bedrock text model once (1 token) as the backend's AWS role and mark which ones this account can use"
              style={{ padding: '10px 16px', backgroundColor: busy ? '#a0aec0' : '#232f3e', color: '#fff', border: 'none', borderRadius: '20px', fontWeight: 'bold', cursor: busy ? 'wait' : 'pointer' }}>
        {busy ? '⏳ Checking Bedrock…' : '🔐 Check Bedrock access'}
      </button>
      {summary && !busy && (
        <button onClick={() => setOpen(!open)} style={{ marginLeft: '6px', background: 'none', border: 'none', color: '#2b6cb0', cursor: 'pointer', fontSize: '12px' }}>
          {summary.region_status && summary.region_status !== 'ALLOWED' ? `⛔ Bedrock ${BEDROCK_LABELS[summary.region_status] || summary.region_status}` : `${c.ALLOWED || 0} available · ${blocked} blocked`}
        </button>)}
      {open && (msg || summary) && (
        <div style={{ position: 'absolute', right: 0, top: '44px', zIndex: 20, width: '360px', background: '#fff', border: '1px solid #cbd5e0', borderRadius: '6px', padding: '10px 12px', boxShadow: '0 4px 10px rgba(0,0,0,0.12)', fontSize: '12px', color: '#333' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
            <strong>Bedrock access for this account</strong>
            <button onClick={() => setOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#888' }}>✕</button>
          </div>
          {msg && <div style={{ color: '#2b6cb0', marginBottom: '6px' }}>{msg}</div>}
          {summary && (
            <div>
              <div style={{ color: '#666', marginBottom: '6px' }}>Account {summary.account || '?'} · {summary.region} · {summary.checked_at}</div>
              {summary.region_status && summary.region_status !== 'ALLOWED'
                ? <div style={{ color: '#721c24' }}>Bedrock itself is {BEDROCK_LABELS[summary.region_status] || summary.region_status} in this region: {summary.region_message}</div>
                : Object.entries(c).filter(([, n]) => n).map(([k, n]) => (
                    <div key={k}>{k === 'ALLOWED' ? '✅' : ['SCP_DENY', 'RCP_DENY', 'IAM_DENY', 'BOUNDARY_DENY', 'SESSION_POLICY_DENY'].includes(k) ? '⛔' : k === 'NO_MODEL_ACCESS' ? '🔒' : k === 'USE_CASE_FORM' ? '📝' : '•'} {BEDROCK_LABELS[k] || k}: <strong>{n}</strong></div>))}
              {(summary.scp_blocked_providers || []).length > 0 && (
                <div style={{ marginTop: '4px', color: '#721c24' }}>SCP blocks: {summary.scp_blocked_providers.join(', ')}</div>)}
              {summary.catalog_marked != null && (
                <div style={{ marginTop: '6px', color: '#555' }}>Marked {summary.catalog_marked} catalog model(s); {summary.catalog_allowed || 0} show “Bedrock available”. Filter with the platform dropdown.</div>)}
            </div>)}
        </div>)}
    </div>);
}

// ⚖️ Compare Models — side-by-side matrix with an LLM verdict column.
// Self-contained (own state + fetch). Candidate models are the REAL models the
// user can see across the tabs (catalog + discovered). No hardcoded seed list —
// only models actually in the system appear, so every row traces to real data.
function ModelComparePanel({ getAuthHeaders, echostarCatalog, otherCatalog, discoveredModels }) {
  // Candidate models = everything the user can see across the three tabs:
  // EchoStar Allowed + Other Models (catalog, model_id) + Market Scanner
  // (discovered, id). Deduped. Only real, in-system models — no seeded entries.
  const idsFrom = (list) => (list || []).map(m => m.model_id || m.id).filter(Boolean);
  const candidates = Array.from(new Set([
    ...idsFrom(echostarCatalog), ...idsFrom(otherCatalog), ...idsFrom(discoveredModels),
  ]));
  // Baseline = the model currently in use / in prod; compare others against it.
  const [baseline, setBaseline] = React.useState(candidates[0] || '');
  // Models selected to compare against the baseline.
  const [selected, setSelected] = React.useState([]);
  const [result, setResult] = React.useState(null);
  const [busy, setBusy] = React.useState(false);
  const [err, setErr] = React.useState('');
  // Search text for the baseline dropdown and the candidate multi-select.
  const [baseSearch, setBaseSearch] = React.useState('');
  const [candSearch, setCandSearch] = React.useState('');
  const [baseOpen, setBaseOpen] = React.useState(false);

  const toggle = (m) => setSelected(s => s.includes(m) ? s.filter(x => x !== m) : [...s, m]);
  const run = async () => {
    setErr(''); setBusy(true); setResult(null);
    try {
      const res = await fetch('/api/compare-models', {
        method: 'POST', headers: getAuthHeaders(),
        // Send the baseline AND the selected comparison models as rows; the
        // baseline appears marked and the others are judged against it.
        body: JSON.stringify({ models: Array.from(new Set([baseline, ...selected])), baseline, verdicts: true }),
      });
      const d = await res.json();
      if (!res.ok) { setErr(d.error || 'Comparison failed'); } else { setResult(d); }
    } catch (e) { setErr('API error running comparison'); }
    finally { setBusy(false); }
  };

  const srcBadge = (source) => {
    if (source === 'measured') return null;
    const map = { seeded: { bg: '#e7f0ff', fg: '#0b5cad', t: 'seeded' }, simulated: { bg: '#fff3cd', fg: '#8a6d00', t: 'SIMULATED' } };
    const s = map[source] || map.simulated;
    return <span style={{ marginLeft: '4px', fontSize: '8px', fontWeight: 'bold', background: s.bg, color: s.fg, padding: '1px 4px', borderRadius: '6px', verticalAlign: 'middle' }}>{s.t}</span>;
  };
  // A blank cell (no measured value) shows just "—" with NO provenance badge —
  // absence of data is not a fabricated estimate.
  const cell = (c) => (c == null || c.value == null) ? '—' : <span>{String(c.value)}{srcBadge(c.source)}</span>;
  // Context window: render token counts compactly (200000 -> 200K, 1000000 -> 1M).
  const ctxCell = (c) => {
    if (c == null || c.value == null) return '—';
    const n = Number(c.value);
    const s = n >= 1000000 ? `${(n / 1000000).toFixed(n % 1000000 ? 1 : 0)}M`
            : n >= 1000 ? `${Math.round(n / 1000)}K` : String(n);
    return <span>{s}{srcBadge(c.source)}</span>;
  };
  const verdictColor = (call) => ({ switch: '#28a745', keep: '#6c757d', deprecate: '#dc3545', baseline: '#0073bb' }[call] || '#4a5568');

  return (
    <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '18px' }}>
      <h3 style={{ marginTop: 0, color: '#0f2027' }}>⚖️ Compare Models</h3>
      <p style={{ fontSize: '12px', color: '#666', marginTop: '-6px' }}>
        Side-by-side model cards with an LLM verdict vs a baseline (switch / keep / deprecate), for the AI Office
        model-selection process. Measured values come from real catalog scorecards; a figure the system has not
        measured shows blank and flagged <strong>SIMULATED</strong> — never a fabricated estimate.
        <br/><strong>Context</strong> is live from the market scanner; <strong>price</strong> and <strong>caching</strong> come from the
        admin pricing table (Admin → pricing) or the scanner's live price — caching shows blank until a real figure is entered (never guessed).
      </p>
      <div style={{ fontSize: '12px', color: '#664d03', background: '#fff3cd', border: '1px solid #ffe69c', borderRadius: '6px', padding: '8px 12px', marginBottom: '12px' }}>
        ⚠️ <strong>Scope:</strong> verdicts here are <strong>guidance for AI-development tooling</strong> selection (e.g. which Claude tier to use for agentic dev).
        A <strong>switch</strong> is <strong>not</strong> an instruction to migrate a production App — moving the model behind an App requires a measured
        per-app head-to-head (modeled &amp; tested) and AI Office review.
      </div>
      <div style={{ display: 'flex', gap: '18px', flexWrap: 'wrap', alignItems: 'flex-start', marginBottom: '14px' }}>
        <div style={{ minWidth: '260px' }}>
          <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#718096', marginBottom: '6px' }}>Current model (in use / baseline)</div>
          {/* Searchable baseline dropdown: a text box that filters a popover list. */}
          <div style={{ position: 'relative', width: '260px' }}>
            <input value={baseOpen ? baseSearch : baseline}
              onChange={e => { setBaseSearch(e.target.value); setBaseOpen(true); }}
              onFocus={() => { setBaseOpen(true); setBaseSearch(''); }}
              placeholder="Search current model…"
              style={{ padding: '6px', fontSize: '12px', border: '1px solid #ccc', borderRadius: '4px', width: '100%', boxSizing: 'border-box' }} />
            {baseOpen && (
              <div style={{ position: 'absolute', zIndex: 20, background: '#fff', border: '1px solid #cbd5e0', borderRadius: '4px', width: '100%', maxHeight: '200px', overflowY: 'auto', boxShadow: '0 4px 12px rgba(0,0,0,0.12)' }}>
                {candidates.filter(m => m.toLowerCase().includes(baseSearch.toLowerCase())).map(m => (
                  <div key={m} onClick={() => { setBaseline(m); setSelected(s => s.filter(x => x !== m)); setBaseOpen(false); setBaseSearch(''); }}
                    style={{ padding: '6px 8px', fontSize: '12px', cursor: 'pointer', background: m === baseline ? '#eef6fc' : '#fff' }}>{m}</div>
                ))}
                {candidates.filter(m => m.toLowerCase().includes(baseSearch.toLowerCase())).length === 0 && (
                  <div style={{ padding: '6px 8px', fontSize: '11px', color: '#a0aec0' }}>No match</div>
                )}
              </div>
            )}
          </div>
          <button onClick={run} disabled={busy || selected.length < 1} style={{ display: 'block', marginTop: '10px', padding: '8px 16px', border: 'none', background: '#6f42c1', color: '#fff', borderRadius: '4px', cursor: busy || selected.length < 1 ? 'default' : 'pointer', fontWeight: 'bold', fontSize: '12px', opacity: busy || selected.length < 1 ? 0.6 : 1 }}>
            {busy ? 'Comparing…' : `Compare ${selected.length || ''} vs current`}
          </button>
        </div>
        <div style={{ flex: '1 1 320px' }}>
          <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#718096', marginBottom: '6px' }}>Candidate models to compare against it</div>
          {/* Searchable multi-select: search box filters; checked chips shown above. */}
          {selected.length > 0 && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: '6px' }}>
              {selected.map(m => (
                <span key={m} onClick={() => toggle(m)} title="remove"
                  style={{ fontSize: '11px', background: '#6f42c1', color: '#fff', borderRadius: '10px', padding: '2px 8px', cursor: 'pointer' }}>{m} ✕</span>
              ))}
            </div>
          )}
          <input value={candSearch} onChange={e => setCandSearch(e.target.value)} placeholder="Search models to add…"
            style={{ padding: '6px', fontSize: '12px', border: '1px solid #ccc', borderRadius: '4px', width: '100%', boxSizing: 'border-box', marginBottom: '6px' }} />
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', maxHeight: '160px', overflowY: 'auto' }}>
            {candidates.filter(m => m !== baseline && m.toLowerCase().includes(candSearch.toLowerCase())).map(m => (
              <label key={m} style={{ fontSize: '11px', display: 'flex', alignItems: 'center', gap: '4px', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '3px 8px', background: selected.includes(m) ? '#eef6fc' : '#fff' }}>
                <input type="checkbox" checked={selected.includes(m)} onChange={() => toggle(m)} />{m}
              </label>
            ))}
          </div>
        </div>
      </div>
      {err && <div style={{ color: '#b00020', fontSize: '12px', marginBottom: '10px' }}>{err}</div>}
      {result && (
        <div style={{ overflowX: 'auto' }}>
          {result.any_simulated && (
            <div style={{ fontSize: '11px', background: '#fff3cd', color: '#8a6d00', padding: '6px 10px', borderRadius: '4px', marginBottom: '8px' }}>
              ⚠️ This comparison includes SIMULATED (estimated) values for models not run live. They are flagged per cell and must not be cited as measured benchmark results.
            </div>
          )}
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
            <thead>
              <tr style={{ background: '#f7fafc', textAlign: 'left' }}>
                <th style={{ padding: '8px' }}>Model</th>
                <th style={{ padding: '8px' }}>Tier</th>
                <th style={{ padding: '8px' }}>Gen</th>
                <th style={{ padding: '8px' }}>Quality</th>
                <th style={{ padding: '8px' }}>P95 ms</th>
                <th style={{ padding: '8px' }}>$/1M (blended)</th>
                <th style={{ padding: '8px' }}>Context</th>
                <th style={{ padding: '8px' }}>Caching</th>
                <th style={{ padding: '8px' }}>Governance</th>
                <th style={{ padding: '8px' }}>Recommendation<br/><span style={{ fontSize: '9px', fontWeight: 'normal', color: '#888' }}>(tooling guidance)</span></th>
              </tr>
            </thead>
            <tbody>
              {result.rows.map(r => {
                const isBase = r.model_id === result.baseline;
                const v = r.verdict || {};
                return (
                  <tr key={r.model_id} style={{ borderTop: '1px solid #edf2f7', background: isBase ? '#f0f7ff' : '#fff' }}>
                    <td style={{ padding: '8px', fontWeight: 'bold' }}>{r.model_id}{isBase ? ' ★' : ''}</td>
                    <td style={{ padding: '8px' }}>{cell(r.tier)}</td>
                    <td style={{ padding: '8px' }}>{cell(r.gen)}</td>
                    <td style={{ padding: '8px' }}>{cell(r.quality)}</td>
                    <td style={{ padding: '8px' }}>{cell(r.p95_latency_ms)}</td>
                    <td style={{ padding: '8px' }}>{cell(r.blended_usd_per_1m)}</td>
                    <td style={{ padding: '8px' }}>{ctxCell(r.context_window)}</td>
                    <td style={{ padding: '8px' }}>{cell(r.caching)}</td>
                    <td style={{ padding: '8px', fontSize: '11px' }}>{cell(r.governance)}</td>
                    <td style={{ padding: '8px' }}>
                      <span style={{ fontWeight: 'bold', textTransform: 'uppercase', color: verdictColor(v.call) }}>{v.call || '—'}</span>
                      {v.rationale && <div style={{ color: '#555', marginTop: '2px' }}>{v.rationale}</div>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
